<template>
  <div>
    <validationObserver ref="addDataForm" tag="form">
      <form>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2">ชื่อรุ่น</label>
          <div class="col-lg-8">
            <validationProvider
              v-slot="{ errors }"
              name="Thai Name"
              :rules="{
                dynamicRequired: [
                  'กรุณาระบุชื่อรุ่นเป็นภาษาไทย หากไม่มี กรุณาระบุเป็นภาษาอังกฤษ',
                ],
                duplicateName: [
                  isValidate.display_name_th,
                  'ชื่อรุ่นภาษาไทยหรือภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                ],
                validateSeriesAndAttributeThaiWithSpecialCharacters: true,
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">TH</span>
                </span>
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  maxlength="30"
                  v-model="componentModel.display_name.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-validate-length">
                  {{ componentModel.display_name.th.length }}/30
                </span>
                <!-- <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ componentModel.display_name.th.length }}/30
                  </span>
                </span> -->
              </div>

              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2"></label>
          <div class="col-lg-8">
            <validationProvider
              v-slot="{ errors }"
              name="English Name"
              :rules="{
                dynamicRequired: ['กรุณาระบุชื่อรุ่นเป็นภาษาอังกฤษ'],
                duplicateName: [
                  isValidate.display_name_en,
                  'ชื่อรุ่นภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                ],
                validateSeriesAndAttributeEngWithSpecialCharacters: true,
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">EN</span>
                </span>
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  maxlength="30"
                  v-model="componentModel.display_name.en"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-validate-length">
                  {{ componentModel.display_name.th.length }}/30
                </span>
                <!-- <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ componentModel.display_name.en.length }}/30
                  </span>
                </span> -->
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-lg-2">สถานะ</label>
          <div class="col-lg-2">
            <basic-select
              :options="optionsStatus"
              :reload="reloadStatusSelector"
              :selected-option="{
                text: componentModel.status,
                value: componentModel.status,
              }"
              @select="onStatusSelector($event)"
              placeholder="ระบุสถานะ"
              v-bind:isError="isValidate.status"
            >
            </basic-select>
          </div>
        </div>
      </form>
    </validationObserver>
    <series-product-relate
      v-if="isShowProductRelate"
      :seriesId="componentModel.id"
    ></series-product-relate>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import seriesService from '@/helpers/service/series-service'
import { BasicSelect } from 'vue-search-select'
import { OptionDropdownStatus } from '@/helpers/utils/status.js'
import SeriesProductRelate from '@/components/series/product-relate'

export default {
  name: 'SeriesDetailEditor',
  components: {
    'basic-select': BasicSelect,
    'series-product-relate': SeriesProductRelate,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.componentModel
      },
    },
    mode: {
      type: String,
      default: () => {
        return 'new'
      },
    },
    isChanged: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    isShowProductRelate: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  mounted() {
    console.log('mode', this.mode)
    if (this.mode === 'edit') {
      this.optionsStatus = OptionDropdownStatus
    } else {
      this.optionsStatus = OptionDropdownStatus.filter(
        q => q.value !== StatusEnum.DELETE
      )
    }
  },
  data() {
    return {
      componentModel: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
      },
      componentModelOriginal: {},
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        status: false,
      },
      optionsStatus: [],
      reloadStatusSelector: false,
      canUpdateDeleteStatus: {
        isDelete: true,
        isConfirm: '',
      },
    }
  },
  created: function() {
    if (this.value) {
      this.componentModel = this.value
      this.componentModelOriginal = JSON.parse(JSON.stringify(this.value))
      this.getSeriesProductSku()
    }
  },
  computed: {},
  watch: {
    value: {
      handler(val) {
        this.componentModel = val
        // this.componentModelOriginal = Object.assign({},val)
      },
      deep: true,
    },
    componentModel: {
      handler(val) {
        if (this.componentModelOriginal) {
          if (
            JSON.stringify(this.componentModel) !==
            JSON.stringify(this.componentModelOriginal)
          )
            this.$emit('update:isChanged', true)
          else this.$emit('update:isChanged', false)
        }
      },
      deep: true,
    },
  },
  methods: {
    async getSeriesProductSku() {
      var result = await seriesService.getSeriesProductSkuListAsync(
        this.componentModel.id
      )
      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (countStatusProductDelete === result.data.skus.length) {
          this.canUpdateDeleteStatus = {
            isDelete: true,
            isConfirm: true,
          }
        } else if (
          countStatusProductAnother === result.data.skus.length ||
          (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
        )
          this.canUpdateDeleteStatus = {
            isDelete: false,
            isConfirm: false,
          }
      }
    },
    async onValidateDisplaynameTH() {
      console.log('mode', this.mode)
      if (
        !(
          this.componentModel.display_name.th === undefined ||
          this.componentModel.display_name.th === null ||
          this.componentModel.display_name.th.trim() === '' ||
          this.componentModel.display_name.th.trim() === null ||
          this.componentModel.display_name.th.trim() === undefined
        )
      ) {
        if (
          this.componentModelOriginal.display_name.th.trim() ===
          this.componentModel.display_name.th.trim()
        ) {
          this.isValidate.display_name_th = false
          return
        }

        let params = new URLSearchParams()
        params.append('nameTh', this.componentModel.display_name.th.trim())
        if (this.mode === 'edit') {
          params.append('id', this.componentModel.id)
        }
        let result = await seriesService.headSeriesMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.componentModel.display_name.en === undefined ||
          this.componentModel.display_name.en === null ||
          this.componentModel.display_name.en.trim() === '' ||
          this.componentModel.display_name.en.trim() === null ||
          this.componentModel.display_name.en.trim() === undefined
        )
      ) {
        if (
          this.componentModelOriginal.display_name.en.trim() ===
          this.componentModel.display_name.en.trim()
        ) {
          this.isValidate.display_name_en = false
          return
        }

        let params = new URLSearchParams()
        params.append('nameEn', this.componentModel.display_name.en.trim())
        if (this.mode === 'edit') {
          params.append('id', this.componentModel.id)
        }
        let result = await seriesService.headSeriesMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onStatusSelector(data) {
      this.isValidate.status = false
      this.reloadStatusSelector = false

      if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        this.canUpdateDeleteStatus.isConfirm
      ) {
        this.$utils
          .confirmAlertDisplay(
            `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่`,
            ''
          )
          .then(result => {
            if (result) this.componentModel.status = data.text ? data.text : ''
          })
      } else if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        !this.canUpdateDeleteStatus.isConfirm
      ) {
        this.componentModel.status = data.text ? data.text : ''
      } else if (
        data.text === StatusEnum.DELETE &&
        !this.canUpdateDeleteStatus.isDelete
      ) {
        this.$utils.notification(
          'warning',
          'มีสินค้าสถานะพร้อมขายอยู่ในรุ่นนี้ ไม่สามารถปรับสถานะเป็น Delete ได้',
          2000
        )
      } else {
        this.componentModel.status = data.text ? data.text : ''
      }
    },
    async checkUploadImage() {
      return true
    },
  },
}
</script>
